
import LocalStorageImpl from '@/serviceImpl/LocalStorageImpl';

const getCredentialsUseCase = () => LocalStorageImpl.getCredentials();

export default getCredentialsUseCase;